import { ref } from 'vue'

const PREFIX = 'dc.home.notice.'

function read(key: string): boolean {
  if (typeof localStorage === 'undefined') return false
  try {
    return localStorage.getItem(PREFIX + key) === '1'
  } catch {
    return false
  }
}

function write(key: string, folded: boolean): void {
  if (typeof localStorage === 'undefined') return
  try {
    if (folded) localStorage.setItem(PREFIX + key, '1')
    else localStorage.removeItem(PREFIX + key)
  } catch {
    /* private mode */
  }
}

/**
 * Home letter / next-set panels: collapse ("collect") and remember in
 * localStorage so the full copy stays hidden until the player expands again.
 */
export function useHomeNoticeFold(id: string) {
  const folded = ref(read(id))

  function collect(): void {
    folded.value = true
    write(id, true)
  }

  function expand(): void {
    folded.value = false
    write(id, false)
  }

  function toggle(): void {
    if (folded.value) expand()
    else collect()
  }

  return { folded, collect, expand, toggle }
}
